// extracted by mini-css-extract-plugin
export default {"settingsForm":"settingsForm__ZSjbe","checkboxRow":"checkboxRow__attY7","checkboxLabel":"checkboxLabel__cHV1E","checkboxField":"checkboxField__hX1YZ","labelStyle":"labelStyle__N6_Mq"};